import PasswordForm from "./PasswordForm";
import {useContext} from "react";
import {MyContext} from "../context/myContext";

const PasswordChangeBox = () => {
    const {showUserPasswordForm, showTopMenuPasswordForm, handleShowForm} = useContext(MyContext)
    return(
        <div className={`${(showTopMenuPasswordForm || showUserPasswordForm) ? 'top-[100px] block' : 'hidden'} absolute left-1/2
         -translate-x-1/2 -top-1/2 w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] bg-white px-5 transition-all duration-1000 z-20 rounded-md`}>
            <div className="flex justify-between items-center border-b border-b-borderColor mx-1 sm:mx-3 py-4">
                <i className="fa fa-times text-xl text-slate-400 cursor-pointer hover:text-slate-600" onClick={handleShowForm}></i>
                <span className='mr-3 text-base sm:text-lg'>تغییر رمز عبور</span>
            </div>
            <PasswordForm />
        </div>
    )
}

export default PasswordChangeBox